import Dashboard from '../model/dashboard'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchDashboards(companyID?: string): Promise<RequestResponse<Dashboard[]>> {
  return secureRequest('GET', url('/v2/dashboard', { companyID }))
}
